import React from 'react';
import PropTypes from 'prop-types';

import { LegendOrdinal, LegendItem, LegendLabel } from '@vx/legend';
import { scaleOrdinal } from '@vx/scale';
import PopOver from '@prisjakt/ui-popover';

import * as S from './styles';

const Legend = ({ colors, lines, lineLabels, descriptions, extra }) => {
  const ordinalColorScale = scaleOrdinal({
    domain: lineLabels,
    range: colors,
  });

  return (
    <LegendOrdinal scale={ordinalColorScale}>
      {labels => (
        <S.LegendWrapper extra={Boolean(extra)}>
          <S.LegendLabels>
            {labels.map((label, i) => {
              const height = 10;
              const width = 40;
              return (
                <LegendItem
                  key={`legend-quantile-${i.toString()}`}
                  margin="0 20px"
                >
                  <svg width={width} height={height}>
                    <line
                      fill="transparent"
                      x1="0"
                      y1="0"
                      x2={width}
                      y2="0"
                      stroke={label.value}
                      strokeWidth={4}
                      strokeDasharray={
                        lines[i] && lines[i] === 'dashed' ? '6,3' : 0
                      }
                    />
                    <rect
                      fill={label.value}
                      width={width}
                      height={height}
                      fillOpacity={0.2}
                    />
                  </svg>
                  <LegendLabel align="left" margin="0 0 0 4px">
                    {label.text}
                    {descriptions[i] && (
                      <PopOver
                        width={300}
                        offsetY={5}
                        offsetX={0}
                        position="bottom"
                        breakpoints={{
                          medium: { point: 800, width: 300 },
                          small: { point: 500, width: 100 },
                        }}
                      >
                        <S.InfoIcon size={16} />
                        <p>{descriptions[i]}</p>
                      </PopOver>
                    )}
                  </LegendLabel>
                </LegendItem>
              );
            })}
          </S.LegendLabels>
          {extra && <div>{extra}</div>}
        </S.LegendWrapper>
      )}
    </LegendOrdinal>
  );
};

Legend.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  lines: PropTypes.array.isRequired,
  lineLabels: PropTypes.array.isRequired,
  descriptions: PropTypes.array.isRequired,
  extra: PropTypes.node,
};

Legend.defaultProps = {
  extra: undefined,
};

export default Legend;
